import { BlendResource } from './BlendResource';
import { Blend } from './Blend';
import { RenderDevice } from './RenderDevice';
import { IConcreteResourceCache } from './IResourceCache';
import { ResourceCache } from './ResourceCache';
import { BlendResourcePool } from './BlendResourcePool';

export class DefaultBlendResources {
  static createDefaultBlendResources(
    resourceCache: IConcreteResourceCache,
    renderDevice: RenderDevice
  ): void {
    const existing = resourceCache.getResource(BlendResource.TypeId, 'SourceAlpha_InverseSourceAlpha');
    if (existing) {
      return;
    }

    // Get pool by casting to ResourceCache
    const cache = resourceCache as ResourceCache;
    const pool = (cache as any)._pools?.get(BlendResource.TypeId) as BlendResourcePool;
    if (!pool) {
      console.error('BlendResourcePool not found in resource cache');
      return;
    }

    const blendConfigs = [
      { id: 'SourceAlpha_InverseSourceAlpha', enabled: true, src: Blend.SrcAlpha, dst: Blend.InvSrcAlpha },
      { id: 'One_InverseSourceAlpha', enabled: true, src: Blend.One, dst: Blend.InvSrcAlpha },
      { id: 'One_InverseSourceColor', enabled: true, src: Blend.One, dst: Blend.InvSrcColor },
      { id: 'One_One', enabled: true, src: Blend.One, dst: Blend.One },
      { id: 'disabled', enabled: false, src: Blend.Zero, dst: Blend.Zero }
    ];

    try {
      for (const config of blendConfigs) {
        const existingResource = resourceCache.getResource(BlendResource.TypeId, config.id);
        if (existingResource) {
          continue;
        }

        const resource = pool.create(config.id);
        const blendState = renderDevice.createBlend(config.enabled, config.src, config.dst);
        
        if (blendState) {
          resource.construct(blendState);
        } else {
          console.error(`Failed to create blend state for resource: ${config.id}`);
        }
      }
    } catch (error) {
      console.error('Failed to create default blend resources:', error);
    }
  }
}